import { BlazeDropdownItem } from 'components/ui/dropdown/BlazeDropdown/BlazeInputDropdown';
import _ from 'lodash';
import { CraneLocation, GROUP_CLOUD_LOCATIONS, LOCATION_MOCK_SERVICES } from 'types/rest/locationTypes';
import { PROVIDER_CLOUD, PROVIDER_OPL } from '../constants/bzm-constants';

export const TRANSACTIONAL_LOCATIONS_ID_SUFFIX = 'transactionalLocId';

/**
 * Creates list of crane locations based on different func-ids of the location. This means location
 * can appear in the dropdown multiple times when it has more func-ids available. Always under different
 * group.
 * @param locations
 */
export const createCraneLocationsDropDownItemsByFuncIds = (locations: CraneLocation[]) => {
  // Bzm Locations
  const bzmLocations: BlazeDropdownItem[] = [];
  if (locations && locations.length !== 0) {
    _.forEach(locations, (locationItem: CraneLocation) => {
      const dropDownItem: BlazeDropdownItem = {
        id: locationItem.shipId,
        name: locationItem.shipName,
        group: locationItem.provider,
      };

      //Group rename
      if (locationItem.provider === PROVIDER_CLOUD) {
        dropDownItem.group = GROUP_CLOUD_LOCATIONS;
        bzmLocations.push(dropDownItem);
      } else {
        if (locationItem.funcIds.filter(fc => fc === LOCATION_MOCK_SERVICES).length > 0) {
          dropDownItem.id = locationItem.shipId + TRANSACTIONAL_LOCATIONS_ID_SUFFIX;
          dropDownItem.name = locationItem.harborName + ' - ' + locationItem.shipName;
          bzmLocations.push(dropDownItem);
        }
      }
    });
  }
  return bzmLocations;
};

/**
 * Creates dropdown items for all crane locations.
 * Items are listed under "VS Environments" group.
 * @param locations
 */
export const createAllCraneLocations = (locations: CraneLocation[]) => {
  // Bzm Locations
  const craneLocations: BlazeDropdownItem[] = [];
  if (locations && locations.length !== 0) {
    _.forEach(locations, (locationItem: CraneLocation) => {
      const groupName = locationItem.provider === PROVIDER_CLOUD ? GROUP_CLOUD_LOCATIONS : PROVIDER_OPL;

      // If harbor name is missing, use just ship name for now
      const name = locationItem.harborName
        ? locationItem.harborName + ' - ' + locationItem.shipName
        : locationItem.shipName;

      const dropDownItem: BlazeDropdownItem = {
        id: locationItem.shipId,
        name: name,
        group: groupName,
        metaData: locationItem,
      };
      craneLocations.push(dropDownItem);
    });
  }
  return craneLocations;
};

/**
 * Creates dropdown items for transactional locations.
 * @param locations - all locations (cloud ones, private ones with funcIds)
 */
export const createTransactionalLocations = (locations: CraneLocation[], isPrivateDataEnabled: boolean) => {
  // Bzm Locations
  const craneLocations: BlazeDropdownItem[] = [];
  if (locations && locations.length !== 0) {
    _.forEach(locations, (craneLocation: CraneLocation) => {
      const isPublicCloudLocation = craneLocation.provider === PROVIDER_CLOUD;
      const groupName = isPublicCloudLocation ? GROUP_CLOUD_LOCATIONS : PROVIDER_OPL;

      let name = craneLocation.harborName
        ? craneLocation.harborName + ' - ' + craneLocation.shipName
        : craneLocation.shipName;

      // For cloud locations, omit the harbor name
      if (isPublicCloudLocation) {
        name = craneLocation.shipName;
      }

      const dropDownItem: BlazeDropdownItem = {
        id: craneLocation.shipId,
        name: name,
        group: groupName,
        metaData: craneLocation,
      };

      // Include the location item if:
      //  it is is public location (support of txn is turn on by default for such) and we are not in private cloud OR
      //  it is private location supporting transactional services
      if (
        (isPublicCloudLocation && !isPrivateDataEnabled) ||
        (craneLocation.funcIds && craneLocation.funcIds.filter(fc => fc === LOCATION_MOCK_SERVICES).length > 0)
      ) {
        craneLocations.push(dropDownItem);
      }
    });
  }
  return craneLocations;
};
